export default function (instance) {
  return {
    list_info() {
      return instance.post("list_info", {});
    },
  };
}
